import { render, staticRenderFns } from "./passwordForm.vue?vue&type=template&id=5f2ece36&scoped=true"
import script from "./passwordForm.vue?vue&type=script&lang=js"
export * from "./passwordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2ece36",
  null
  
)

export default component.exports